export default __webpack_public_path__ + "static/media/email.0603fea7.svg";